import { render, staticRenderFns } from "./Witholding.vue?vue&type=template&id=61e6e8f7"
import script from "./Witholding.vue?vue&type=script&lang=js"
export * from "./Witholding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports